function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var React = require("react");

var styled = require("styled-components").default;

var Header = require("../main-header");

var NavigationTree = require("../navigation-tree");

var NavigationToolbar = require("../navigation-toolbar");

var NavigationLabel = require("../navigation-label");

var Navigation =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Navigation, _React$Component);

  function Navigation() {
    var _ref;

    var _this;

    _classCallCheck(this, Navigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_ref = Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call.apply(_ref, [this].concat(args)));
    _this.getRef = _this.getRef.bind(_assertThisInitialized(_this));
    _this.handleScrollRequest = _this.handleScrollRequest.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Navigation, [{
    key: "handleScrollRequest",
    value: function handleScrollRequest(e) {// noop
    }
  }, {
    key: "getRef",
    value: function getRef(ref) {
      this.ref = ref;
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var children = React.Children.toArray(props.children);
      var toolbar = children.find(function (child) {
        return child.type === NavigationToolbar;
      });
      var header = children.find(function (child) {
        return child.type === NavigationHeader;
      });
      return React.createElement(StyledNavigation, {
        onKeyDown: this.handleKeyDown
      }, header ? header : React.createElement(StyledHeader, {
        title: props.applicationTitle,
        symbol: "patternplate"
      }), React.createElement(StyledNavigationTree, {
        ref: this.getRef
      }, React.createElement(Documentation, {
        visible: props.docs.children.length > 0,
        active: props.active,
        docs: props.docs,
        onItemClick: props.onItemClick,
        onLabelClick: props.onLabelClick,
        onScrollRequest: this.handleScrollRequest,
        query: props.query
      }), props.showComponents && React.createElement(React.Fragment, null, React.createElement(NavigationLabel, {
        visible: props.navigation.children.length > 0,
        enabled: props.componentsEnabled,
        name: "components",
        highlight: true,
        onClick: props.onLabelClick,
        size: "S"
      }, "Components"), React.createElement(NavigationTree, {
        name: "components",
        visible: props.componentsEnabled && props.navigation.children.length > 0,
        active: props.active,
        data: props.navigation.children,
        onItemClick: props.onItemClick,
        onScrollRequest: this.handleScrollRequest,
        prefix: "/component",
        query: props.query
      }))), toolbar && React.createElement(StyledNavigationToolbar, null, toolbar));
    }
  }]);

  return Navigation;
}(React.Component);

module.exports = Navigation;
module.exports.NavigationToolbar = NavigationToolbar;
module.exports.NavigationHeader = NavigationHeader;
Navigation.defaultProps = {
  tools: []
};

function NavigationHeader(props) {
  return React.createElement(StyledNavigatHeader, null, props.children);
}

var StyledNavigatHeader = styled.div.withConfig({
  displayName: "main-navigation__StyledNavigatHeader"
})(["box-sizing:border-box;min-height:60px;background:", ";"], function (props) {
  return props.theme.colors.backgroundSecondary;
});

function getPadding(el) {
  var style = global.getComputedStyle(el, null);
  return function (direction) {
    return parseInt(style.getPropertyValue("padding-".concat(direction)), 10);
  };
}

var StyledHeader = styled(Header).withConfig({
  displayName: "main-navigation__StyledHeader"
})(["height:60px;box-sizing:border-box;flex-shrink:0;"]);
var StyledNavigation = styled.div.withConfig({
  displayName: "main-navigation__StyledNavigation"
})(["display:flex;height:100%;flex-direction:column;justify-content:space-between;position:relative;background-color:", ";"], function (props) {
  return props.theme.colors.background;
});
var PASSAGE_HEIGHT = 50;
var StyledNavigationTree = styled.div.withConfig({
  displayName: "main-navigation__StyledNavigationTree"
})(["flex-grow:1;flex-shrink:1;overflow-x:hidden;overflow-y:scroll;scroll-behavior:smooth;-webkit-overflow-scroll:touch;mask-image:linear-gradient( to top,rgba(0,0,0,0),rgba(0,0,0,1) ", "px );-webkit-mask-image:linear-gradient( to top,rgba(0,0,0,0),rgba(0,0,0,1) ", "px );& > *:last-child{margin-bottom:", "px;}@media screen{mask-image:none;-webkit-mask-image:none;}"], PASSAGE_HEIGHT, PASSAGE_HEIGHT, PASSAGE_HEIGHT);
var StyledNavigationToolbar = styled.div.withConfig({
  displayName: "main-navigation__StyledNavigationToolbar"
})(["flex-grow:0;flex-shrink:0;"]);

function Documentation(props) {
  return React.createElement(StyledDocumentationTree, {
    visible: props.visible,
    active: props.active,
    data: props.docs.children,
    onItemClick: props.onItemClick,
    onLabelClick: props.onLabelClick,
    onScrollRequest: props.onScrollRequest,
    prefix: "/doc",
    query: props.query
  });
}

var StyledDocumentationTree = styled(NavigationTree).withConfig({
  displayName: "main-navigation__StyledDocumentationTree"
})(["margin-bottom:5px;padding-bottom:5px;"]);
//# sourceMappingURL=index.js.map